import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Trophy, Store, MapPin } from 'lucide-react';

const ShopSellers = ({ styles, sellers = [] }) => {
  const formatShopName = (shopName) => {
    if (!shopName) return 'unnamed-shop';
    return shopName.toLowerCase().replace(/\s+/g, '-');
  };

  const visibleSellers = (sellers || []).filter(seller => {
    if (!seller) return false;
    const shopName = seller.shopInfo?.shopName;
    if (!shopName || shopName.trim() === '' || shopName === 'Unnamed Shop') return false;
    if (!seller.productCount || seller.productCount <= 0) return false;
    return true;
  });

  if (visibleSellers.length === 0) {
    return (
      <div className="w-full p-4 text-center text-gray-600">
        No stores available at the moment.
      </div>
    );
  }

  return (
    <div
      className={`${
        styles === 'grid'
          ? 'grid-cols-3 md-lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 grid'
          : 'w-[400px] md-lg:w-auto grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1'
      } gap-3`}
    >
      {visibleSellers.map((seller, i) => {
        const shopInfo = seller.shopInfo || {};
        const shopName = shopInfo.shopName;
        const description = shopInfo.description || 'No description available.';

        return (
          <div
            key={i}
            className="bg-white border border-gray-100 group transition-all duration-500 hover:shadow-md cursor-pointer"
          >
            <div className="relative overflow-hidden">
              <div className="absolute left-2 top-2 flex flex-col gap-1 z-10">
                {seller.isTopSeller && (
                  <div className="flex justify-center items-center text-black py-[2px] px-4 rounded-full bg-yellow-400 font-semibold text-s">
                    Top Seller <Trophy size={16} className="ml-2" />
                  </div>
                )}
              </div>

              <Link
                to={`/stores/${formatShopName(shopName)}/${seller._id}`}
                className="block"
              >
                {seller.image ? (
                  <img
                    className="sm:w-full w-full h-[240px] nex_img_cover"
                    src={seller.image}
                    alt={`${shopName} store`}
                    onError={e => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                ) : null}
                <div
                  className="sm:w-full w-full h-[240px] bg-gray-100 items-center justify-center flex-col gap-2 text-gray-400"
                  style={{ display: seller.image ? 'none' : 'flex' }}
                >
                  <Store size={40} />
                  <span className="text-sm font-medium">{shopName}</span>
                </div>
              </Link>
            </div>

            <div className="py-3 text-slate-white px-2">
              <div className="flex justify-between items-center gap-3 p-2">
                <h2 className="text-lg font-bold">{shopName}</h2>
              </div>

              <div className="p-2 text-gray-500">
                {description.length > 100
                  ? `${description.slice(0, 100)}...`
                  : description}
              </div>

              <div className="p-2 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Package size={20} />
                  <span>{seller.productCount || 0} Products</span>
                </div>
                <Link
                  to={`/stores/${formatShopName(shopName)}/${seller._id}`}
                  className="nex_button_main font-semibold border border-gray-200 hover:bg-[#FFE11B] hover:border-[#FFE11B] hover:text-black px-4 py-2 flex items-center"
                >
                  Visit store
                </Link>
              </div>
              {(shopInfo.division || shopInfo.district) && (
                <div className="px-2 pb-2 flex items-center gap-1 text-xs text-gray-400">
                  <MapPin size={11} />
                  <span>{[shopInfo.division, shopInfo.district].filter(Boolean).join(', ')}</span>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ShopSellers;